<template>
    <div>
        <div class="flex">
            <p class="text-base font-semibold pb-1">Show your Polished Entries?</p>

            <toggle-button
                v-model="config.showAnnotations"
                :labels="{checked: 'Shown', unchecked: 'Hidden'}"
                :width="70"
                class="mx-2"
            />
        </div>

        <p class="text-xs font-normal text-gray-780">Only your own initial Entries and their comment will be displayed. All replies, and Entries from other people, will not be displayed on your profile.</p>

        <div v-if="config.showAnnotations">
            <label class="flex items-center text-gray-800 font-semibold">
                <input class="mr-2 leading-tight"
                    type="checkbox"
                    v-model="config.highlights"
                >

                <p class="text-sm leading-loose pb-0">Highlights</p>
            </label>

            <label class="flex items-center text-gray-800 font-semibold">
                <input class="mr-2 leading-tight"
                    type="checkbox"
                    v-model="config.strikethroughs"
                >

                <p class="text-sm leading-loose pb-0">Strikethroughs</p>
            </label>

            <label class="flex items-center text-gray-800 font-semibold">
                <input class="mr-2 leading-tight"
                    type="checkbox"
                    v-model="config.comments"
                >

                <p class="text-sm leading-loose pb-0">Comments</p>
            </label>

            <label class="flex items-center text-gray-800 font-semibold">
                <input class="mr-2 leading-tight"
                    type="checkbox"
                    v-model="config.tasks"
                >

                <p class="text-sm leading-loose pb-0">Tasks</p>
            </label>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    components: {
        ToggleButton,
    },

    props: {
        initial_config: {},
    },

    data() {
        return {
            config: Object.assign({
                showAnnotations: false,
                highlights: true,
                strikethroughs: true,
                comments: false,
                tasks: false,
            }, this.initial_config),
        }
    },

    methods: {
        updateConfig() {
            axios.put('/myprofile', { annotator_config: this.config })
                .then(response => {
                    this.$emit('update');
                })
                .catch(error => {
                    console.log(error.response);
                });
        },
    },

    watch: {
        config: {
            deep: true,
            handler() {
                this.updateConfig();
            },
        },
    },
}
</script>
